import React from 'react';
import Udaan2024 from 'views/Udaan2024';
const MathClubPage = () => {
  return <Udaan2024/>;
};
export default MathClubPage;

